import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
import { TableContextConsumer } from '../context';
var TableHead = /** @class */ (function (_super) {
    __extends(TableHead, _super);
    function TableHead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTableHead = function (context) {
            var props = _this.props;
            var classNames = namespacedClassnames('table-head', props.className);
            var gridStyle = {
                gridTemplateColumns: context.colWidths.join(' ')
            };
            return (React.createElement("div", { className: classNames, style: gridStyle }, props.children));
        };
        return _this;
    }
    TableHead.prototype.render = function () {
        return (React.createElement(TableContextConsumer, { render: this.renderTableHead }));
    };
    return TableHead;
}(React.PureComponent));
export { TableHead };
//# sourceMappingURL=table-head.js.map